<template>
    <div class="xcard">
        <div class="row">
            <div class="col-sm-1" v-if="showvolver">
                <v-btn small class="ma-0" @click="$router.back()" color="info" outlined> 
                    <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
                </v-btn>
            </div>
            <div class="col-sm-10">
                <h3 class="text-center my-0"> Gestion de la oferta academica {{ $store.state.CARGO.sede.nombre }} </h3>
            </div>
        </div>

        <div>  
            <v-tabs v-if="perm_posgrado" background-color="primary darken-3" dark class="darken-4" color="blue" centered slider-color="red" v-model="tabs" @change="tab_cmabiado">
                <!-- <v-tab>Con posgrado</v-tab> -->
                <v-tab>Para aprobar</v-tab> 
                <v-tab>Sin posgrado</v-tab> 
                <v-tab>Configuracion</v-tab> 
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <!-- <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <ConPosgrado ref="refConPosgrado" :shared="shared" :isgeneral="isgeneral" />
                        </v-card-text>
                    </v-card>
                </v-tab-item> -->
                
                <v-tab-item>
                    <v-card flat>
                    <v-card-text>
                        <seleccionados_aprob ref="refseleccionados_aprob" :shared="shared" />
                    </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat>
                    <v-card-text>
                        <SinPosgrado ref="refSinPosgrado" :shared="shared" />
                    </v-card-text>
                    </v-card>
                </v-tab-item>
                
                <v-tab-item>
                    <v-card flat>
                    <v-card-text>
                        <configUracion ref="refconfigUracion" :shared="shared" />
                    </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div> 
    </div>
</template>
  
<script>  
// import ConPosgrado from './con_posgrado.vue'
import SinPosgrado from './sin_posgrado.vue'
import seleccionados_aprob from './seleccionados_aprob.vue';
import configUracion from './config/config-uracion.vue';
import { seleccionados_dbs } from '@/views/oferta_academica/servicios/seleccionService.ts';

export default {
    components: { /* ConPosgrado, */SinPosgrado,seleccionados_aprob,configUracion },
    props:{
        showvolver:{type:Boolean, default: true},
        isgeneral:{type:Boolean, default: false},
    },
    data() {
        return {
            tabs: null,
            shared: {mes:null,anio:null},
            perm_posgrado: false,
        };
    },
    watch: { },
    methods: {
        tab_cmabiado(e){  
            if(e==0 && this.$refs.refConPosgrado){
                this.$refs.refConPosgrado.getGestiones()
            }else if(e==1 && this.$refs.refSinPosgrado){
                this.$refs.refSinPosgrado.getGestiones()
            }else if(e==2 && this.$refs.refconfigUracion){
                this.$refs.refconfigUracion.listar_periodos()
            }
        },
        verificar_rol(){
            this.tabs = 0;
            const r = this.$store.state.CARGO.id;
            if(r == 1 || r== 5 || r== 6) {
                this.perm_posgrado = true;
            }            
        },
        async get_seleccionados() {
            seleccionados_dbs()
            
        }
    },
    mounted() {
        this.verificar_rol();
        this.get_seleccionados();
    },
};
</script>
  